import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'

import { GLOBAL_ROUTE_PATHS } from 'Router/Router.constants'

import { ButtonGroup, Card, CardBody, CardHeader } from 'Components/_theme'

interface LostOrStolenNoReplacementModalProps {
  onClose: () => void
}

export const LostOrStolenNoReplacementModal = (
  props: LostOrStolenNoReplacementModalProps,
) => {
  const { onClose } = props
  const navigate = useNavigate()
  const intl = useIntl()

  const handleContactCustomerService = () => {
    onClose()
    navigate(GLOBAL_ROUTE_PATHS.public.contact)
  }

  return (
    <Card>
      <CardHeader icon={faCircleInfo}>
        <FormattedMessage id="LostOrStolen_forceNoReplacement_title" />
      </CardHeader>

      <CardBody>
        <p>
          <FormattedMessage id="LostOrStolen_forceNoReplacement_body" />
        </p>

        <ButtonGroup
          rightButton={{
            onClick: handleContactCustomerService,
            text: intl.formatMessage({
              id: 'LostOrStolen_forceNoReplacement_cta',
            }),
          }}
        />
      </CardBody>
    </Card>
  )
}
